import { TeachingOrgSelect } from 'components/Form'
import { noop } from 'utils'
import { TeachingOrgProps } from 'types'
import { AdvancedInputProps, BasicInputGroup } from '.'
import { useMemo } from 'react'

export interface TeachingOrgInputProps extends AdvancedInputProps {
  value?: string
  teachingOrgs: TeachingOrgProps[]
}

export const TeachingOrgInput = ({
  name,
  label,
  value,
  disabled,
  teachingOrgs,
  setFieldValue,
  onBlur = noop,
  error,
  tabIndex,
}: TeachingOrgInputProps) => {
  const selected = useMemo(
    () => teachingOrgs.find((org) => org.id === value) ?? { name: '', id: '' },
    [teachingOrgs, value]
  )
  const displayText = selected?.name || '-'
  return (
    <BasicInputGroup
      name={name}
      label={label}
      disabled={disabled}
      display={displayText}
      error={error}
      input={
        <TeachingOrgSelect
          id={name}
          data-cy="teaching-organization"
          name={name}
          value={selected}
          disabled={disabled}
          hasErrors={!!error}
          options={teachingOrgs}
          onChange={(org: any) => {
            if (typeof org?.id !== 'string') return
            setFieldValue(name, org.id)
          }}
          onBlur={onBlur}
          tabIndex={tabIndex}
        />
      }
    />
  )
}
